/* WP · Instalación: pasos que controlan el video (o las ilustraciones si aún no hay video). Ecom Project */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__aci) return;
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-aci-step]'));
    if (!steps.length) return;
    root.__aci = true;

    var video = root.querySelector('video');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-aci-slide]'));
    var toggle = root.querySelector('[data-aci-toggle]');
    var auto = root.getAttribute('data-autoplay') !== 'false';
    var interval = (parseFloat(root.getAttribute('data-interval')) || 4) * 1000;
    var active = -1, visible = false, raf = 0;

    function setActive(i, p) {
      if (i !== active) {
        for (var k = 0; k < steps.length; k++) {
          var on = k === i;
          steps[k].classList.toggle('is-active', on);
          var btn = steps[k].querySelector('button');
          if (on) btn.setAttribute('aria-current', 'step'); else btn.removeAttribute('aria-current');
          steps[k].style.setProperty('--p', '0%');
        }
        for (var j = 0; j < slides.length; j++) slides[j].classList.toggle('is-active', j === i);
        active = i;
      }
      steps[i].style.setProperty('--p', (Math.max(0, Math.min(1, p || 0)) * 100).toFixed(1) + '%');
    }

    /* ---------- Con video ---------- */
    if (video) {
      var raw = steps.map(function (s) {
        var v = parseFloat(s.getAttribute('data-start'));
        return isNaN(v) ? null : v;
      });
      var starts = [], ends = [];
      var computeStarts = function () {
        var d = video.duration;
        if (!isFinite(d) || d <= 0) return false;
        var st = raw.slice();
        if (st[0] === null) st[0] = 0;
        var ok = st.every(function (v, k) { return v !== null && v < d && (k === 0 || v > st[k - 1]); });
        if (!ok) st = steps.map(function (s, k) { return k * d / steps.length; });
        starts = st;
        ends = st.map(function (v, k) { return k < st.length - 1 ? st[k + 1] : d; });
        return true;
      };
      var tick = function () {
        if (!starts.length && !computeStarts()) return;
        var t = video.currentTime, i = 0;
        for (var k = 0; k < starts.length; k++) if (t >= starts[k] - 0.05) i = k;
        setActive(i, (t - starts[i]) / Math.max(0.1, ends[i] - starts[i]));
      };
      var loop = function () {
        tick();
        raf = (!video.paused && visible) ? requestAnimationFrame(loop) : 0;
      };
      var startLoop = function () { if (!raf) raf = requestAnimationFrame(loop); };
      var syncPaused = function () { root.classList.toggle('is-paused', video.paused); if (toggle) toggle.setAttribute('aria-label', video.paused ? 'Reproducir video' : 'Pausar video'); };

      video.muted = true;
      video.setAttribute('playsinline', '');
      video.addEventListener('loadedmetadata', function () { computeStarts(); tick(); });
      video.addEventListener('timeupdate', tick);
      video.addEventListener('play', function () { syncPaused(); startLoop(); });
      video.addEventListener('pause', syncPaused);
      if (video.readyState >= 1) computeStarts();
      syncPaused();
      setActive(0, 0);

      steps.forEach(function (s, i) {
        s.querySelector('button').addEventListener('click', function () {
          if (!starts.length) computeStarts();
          var to = starts.length ? starts[i] : 0;
          try { video.currentTime = to + 0.01; } catch (e) {}
          setActive(i, 0);
          root.__userPaused = false;
          var p = video.play(); if (p && p.catch) p.catch(function () {});
        });
      });
      if (toggle) toggle.addEventListener('click', function () {
        if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        else video.pause();
      });

      var onView = function (v) {
        visible = v;
        if (v) { if (auto && !reduce && !root.__userPaused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } startLoop(); }
        else if (!video.paused) video.pause();
      };
      if (toggle) toggle.addEventListener('click', function () { root.__userPaused = video.paused; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { onView(en[0].isIntersecting); }, { threshold: 0.35 }).observe(root);
      } else onView(true);
      return;
    }

    /* ---------- Sin video: ilustraciones que avanzan solas ---------- */
    var t0 = 0, cur = 0;
    var frame = function (now) {
      raf = 0;
      if (!visible) return;
      if (!t0) t0 = now;
      var p = (now - t0) / interval;
      if (p >= 1) { cur = (cur + 1) % steps.length; t0 = now; p = 0; }
      setActive(cur, p);
      raf = requestAnimationFrame(frame);
    };
    var run = function () { if (!raf && visible && !reduce) raf = requestAnimationFrame(frame); };
    setActive(0, 0);
    steps.forEach(function (s, i) {
      s.querySelector('button').addEventListener('click', function () {
        cur = i; t0 = 0; setActive(i, 0); run();
      });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        if (visible) { t0 = 0; run(); } else if (raf) { cancelAnimationFrame(raf); raf = 0; }
      }, { threshold: 0.35 }).observe(root);
    } else { visible = true; run(); }
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-aci]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target && e.target.closest && e.target.closest('[data-aci-step]');
    if (step) { var b = step.querySelector('button'); if (b) b.click(); }
  });
})();